import { InjectionToken } from '@angular/core';

export const RXAP_FORM_INITIAL_STATE = new InjectionToken('rxap/forms/initial-state');
export const RXAP_FORM_CONTEXT = new InjectionToken('rxap/forms/context');
